export const passwordRules = [
  { regex: /.{8,}/, message: 'Minimum 8 characters' },
  { regex: /[A-ZĄĆĘŁŃÓŚŹŻ]/, message: 'Minimum one uppercase letter (A-Z, ĄĆĘŁŃÓŚŹŻ)' },
  {
    regex: /[!@#$%^&*()\[\]{}\\|;:'",.<>/?`~_\-=+]/,
    message: 'Minimum one special character (!, @, #, $, % etc.)',
  },
  { regex: /\d/, message: 'Minimum one number' },
];
